import React, { useState } from 'react';
import { Flex, useDisclosure } from '@chakra-ui/react';
import { useIsMobile } from '#hooks/useIsMobile';
import { BreadcrumbNav, ContentContainer } from '#components';
import { t } from '#i18n';

import { OrganizationsList, RepositoriesList, RepositoriesModal } from './components';

const pathTree = [
  {
    name: t('settings.title'),
    segment: 'settings',
    children: [
      { name: t('settings.manageOrganizations.title'), segment: 'organizations' },
    ],
  },
];

export const ManageOrganizations = () => {
  const isMobile = useIsMobile();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [selectedOrganization, setSelectedOrganization] = useState(null);

  const onSelectOrganization = (organization) => {
    setSelectedOrganization(organization);
    if (isMobile) {
      onOpen();
    }
  };

  return (
    <>
      <ContentContainer topContent={<BreadcrumbNav pathTree={pathTree} />}>
        <Flex>
          <Flex
            flex={1}
            backgroundColor="primary.400"
            border="1px solid"
            borderColor="primary.300"
            borderLeftRadius="md"
            borderRightRadius={{ base: 'md', mobile: 'none' }}
          >
            <OrganizationsList
              selectedOrganization={selectedOrganization}
              onSelectOrganization={onSelectOrganization}
            />
          </Flex>
          {!isMobile && (
          <Flex
            flex={1}
            data-testid="repositories-list"
            backgroundColor="primary.400"
            borderY="1px solid"
            borderRight="1px solid"
            borderColor="primary.300"
            borderRightRadius="md"
          >
            <RepositoriesList selectedOrganization={selectedOrganization} />
          </Flex>
          )}
        </Flex>
      </ContentContainer>
      <RepositoriesModal
        selectedOrganization={selectedOrganization}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
};
